export class Constants {
    /**
     * The key to add a pending intervenor
     */
    public static readonly pendingAddIntervenorKey = "PendingAddIntervenor";
}
